module.exports = __webpack_public_path__ + "img/UlnarGutter.65e03020.svg";